(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/account-selector/assets/javascripts/account-selector-error.js') >= 0) return;  svs.modules.push('/components/numbergames/account-selector/assets/javascripts/account-selector-error.js');

'use strict';

const _svs$numbergames$acco = svs.numbergames.accountSelector.constants,
  UNKNOWN = _svs$numbergames$acco.errors.UNKNOWN,
  errorMessages = _svs$numbergames$acco.errorMessages;
class AccountSelectorError extends Error {
  constructor() {
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? UNKNOWN : _ref$type,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? errorMessages[UNKNOWN] : _ref$message;
    super();
    this.type = type;
    this.message = message;
  }
}
svs.numbergames.accountSelector.AccountSelectorError = AccountSelectorError;

 })(window);